<template>
  <div class="transform-container">
    <div class="global-container next-page-transform">
      <div class="left desktop-only">
        <div class="design">
          <h1 class="title">
            Logiciel de facturation électronique français.
          </h1>

          <div class="separator"></div>

          <h2 class="subtitle">
            Gestion clients, prospection commerciale et comptabilité intégrées.
          </h2>
      </div>
      </div>
      <div class="right choose-group-container">
        <div class="content-container">
          <UserProgress :currentStep="3" :totalSteps="3" style="margin-top: 20px"/>
          <div v-if="!(isJoinGroupSelected || isCreateGroupSelected)" class="choice">
            <h1>Espace entreprise</h1>
            <p>Permet de regrouper les membres d’une même société (collaborateurs, comptable, etc.), pour commencer :</p>
            <ul>
              <li><a class="button-style" @click="createGroupSelected()">Créer</a> et indiquez le nom de votre entreprise</li>
              <li><a class="button-style" @click="joinGroupSelected()">Rejoindre</a> un espace existant</li>
            </ul>
          </div>
          <div v-if="isJoinGroupSelected || isCreateGroupSelected" class="card-container">
            <button @click="back" class="button-icon-custom button-arrow"><span class="fas fa-arrow-left"></span></button>
            <div v-if="isJoinGroupSelected" class="card back-button-padding">
              <h1><strong>Demande d'accès</strong></h1>
              <p>Demandez à un administrateur de votre entreprise de vous ajouter en lui transmettant ce code : </p>
              <div class="clipboard">
                <CustomTextField :content=inputs.userId></CustomTextField>
                <button id="clipboard" class="button-icon-custom button-clipboard">
                  <span class="clipboard-tooltip" :class="{ showed : isClipboardTooltip }">Copié !</span>
                  <span class="fas fa-paste"></span>
                </button>
              </div>
            </div>
            <div v-if="isCreateGroupSelected" class="card back-button-padding">
              <h1><strong>Création</strong></h1>
              <p>Entrez le nom de votre entreprise pour créer votre espace.</p>
              <label v-if="newGroupNameErrorLabel" :class="{ error : this.inputs.newGroupName.error === true, success : this.inputs.newGroupName.error === false }">{{newGroupNameErrorLabel}}</label>
              <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
                <CustomTextField class="default-margin" :content=inputs.newGroupName />
                <CustomButton @click="submitForm" :params=buttons.submit />
              </CustomForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
    import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
    import { library } from '@fortawesome/fontawesome-svg-core'
    import {faArrowLeft, faPaste} from "@fortawesome/free-solid-svg-icons";
    import {GroupController} from "@/controllers/user/GroupController";
    import router from "@/router";
    import CustomForm from "@/components/forms/CustomForm.vue";
    import { NotificationService } from "@vues/v-common";
    import UserProgress from "@/components/userProgress.vue";
    library.add(faArrowLeft);
    library.add(faPaste);

    export default {
        name: 'ChooseGroupView',
        components: {
          UserProgress,
          CustomForm,
          CustomButton,
          CustomTextField
        },
        data() {
          return {
            inputs: {
              newGroupName: {label: 'Nom de l\'entreprise', value: '', type: 'text'},
              userId: {label: 'Code', value: 'Un problème est survenue', type: 'text', readOnly: true}
            },
            buttons:{
              submit: {text: "Valider", disabled: true},
            },
            isCreateGroupSelected: false,
            isJoinGroupSelected: false,
            newGroupNameErrorLabel : undefined,
            newGroupNameDebounceTimeout : undefined,
            userId : "Un problème est survenue",
            isClipboardTooltip : false
          };
        },
      mounted() {
        this.inputs.userId.value = localStorage.userId;
      },
      methods: {
        joinGroupSelected(){
          this.isJoinGroupSelected = true;
          const self = this;
          //add event listner to elementtrigger
          setTimeout(() => {
            let trigger = document.getElementById("clipboard");
            if(trigger) {
              trigger.addEventListener("click", function () {
                //create the readonly textarea with the text in it and hide it
                let tarea = document.createElement("textarea");
                tarea.setAttribute("id", "clipboard" + "-copyarea");
                tarea.setAttribute("readonly", "readonly");
                tarea.setAttribute("style", "opacity: 0; position: absolute; z-index: -1; top: 0; left: -9999px;");
                tarea.appendChild(document.createTextNode(self.inputs.userId.value));
                document.body.appendChild(tarea);

                //select and copy the text in the readonly text area
                tarea.select();
                // TODO Regarder ça
                document.execCommand("copy");

                //remove the element from the DOM
                document.body.removeChild(tarea);

                // Call back
                self.isClipboardTooltip = true;
                setTimeout(() => {
                  self.isClipboardTooltip = false;
                }, 3000);

              });
            }
          }, 1000);
        },
        createGroupSelected(){
          this.isCreateGroupSelected = true;
        },
        async submitForm() {
          const res = await this.$refs.form.submitForm(() => GroupController.post({
            name : this.inputs.newGroupName.value
          }));
          if (!res.errors) {
            (new NotificationService).addNotification("success", "Espace entreprise créé et rejoint");
            (new NotificationService).addNotification("success", "Veuillez vous reconnectez");
            router.push("/login");
          }
        },
        back(){
          this.isCreateGroupSelected = false;
          this.isJoinGroupSelected = false;
        }
      }
    }
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';
  @import 'dualViews.styl'
  .global-container
    display flex
    flex 1
    .left
      flex: 1
    .right
      display flex
      flex: 1
  .choice
    max-width 500px
    h2
      font-weight 500
    ul
      display flex
      flex-direction column
      gap 7px
      .button-style
        background-color THEME_COLOR_PRIMARY
        color THEME_COLOR_PRIMARY_OPPOSITE
        font-weight bold
        cursor pointer
        padding-right 5px
        padding-left 5px
        border-radius 5px

  .choose-group-container
    display flex
    flex-direction column
    flex 1
    width 100%
    align-items center
    justify-content space-between
    .content-container
      display flex
      flex-direction column
      justify-content center
      flex 1
    .card-container
      min-width 300px
      max-width 400px
      .clickable
        cursor pointer
      .clickable:hover
        background-color #6e6e6e
      .back-button-padding
        margin-top -10px
      .card
        border-radius 15px
        display flex
        flex-direction column
        padding-left 40px
        padding-right 40px
        height 100%
        .default-margin
          margin-bottom 20px
        label
          &.error
            color #cd384e
          &.success
            color #1595d4
        h1
          padding-bottom 0
          margin 0
          font-size 1.6em !important
          text-align center
          padding-top 0
          strong
            color #313d5a
      .button-arrow
        width 15px
        margin-top 10px
        margin-left 5px
        left 0
        right auto
  .clipboard
    display flex
    .button-clipboard
      margin-top 20px
      margin-left 10px
      .clipboard-tooltip
        position absolute
        visibility hidden
        opacity 0
        margin-top -45px
        margin-left -15px
        box-shadow 0 0 5px 0 rgba(0, 0, 0, 0.3)
        border-radius 5px
        padding 5px
        transition: visibility 0s, opacity 0.3s linear;
        &.showed
          visibility visible
          opacity 1
  .transform-container
    overflow-x hidden
    display flex
    align-items center
    justify-content center
    flex 1
    height 100%
  .next-page-transform
    animation moveLeft 1s forwards

  @keyframes moveLeft
    from
      transform: translateX(100%);
    to
      transform: translateX(0%);
</style>
